import * as React from "react";

const SvgIcnFacebookBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M14 9h2.566l-.437 3.5H14V20H9.758v-7.5H8V9h1.758V7.82c0-1.214.315-2.166.962-2.83.657-.671 1.694-.99 3.092-.99H16.5v3.5h-1.828c-.366 0-.568.05-.589.072-.043.048-.083.192-.083.444V9z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnFacebookBold;
